/**
 * Автоматический импорт всех router.js из '@/modules' с добавлением префикса
 * в виде названия папки модуля, конвертированного в kebab-case
 */

const getPrefixFromModuleName = (modulePath) => (
  // EXAMPLE: ./CourseManagement/routes.js returns 'course-management'

  modulePath.match('/(.*)/')[1]
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/\s+/g, '-')
    .toLowerCase()
);

const initModules = (router) => {
  const routesModules = require.context('@/modules', true, /routes\.js$/);

  routesModules.keys().forEach((key) => {
    const imortedRoutes = routesModules(key).default;

    imortedRoutes.forEach((item) => {
      const prefixedRoute = {
        ...item,
        path: `/${getPrefixFromModuleName(key)}${item.path}`,
      };
      router.addRoute(prefixedRoute);
    });
  });
};

export default initModules;
